import { css } from "@emotion/react";

export const searchButton = css`
  border: none;
  width: auto;

  svg {
    height: 1rem;
  }
`;
